// extracted by mini-css-extract-plugin
export default {"btn":"UserList_btn__ylmOI","btn--selected":"UserList_btn--selected__R6Vph","btn__avatar":"UserList_btn__avatar__uHSUe","btn__text":"UserList_btn__text__mYiZC"};